<button
	#button
	mat-raised-button
	[style.height.px]="height + shadowHeight"
	[style.border-radius.px]="radius"
	[color]="color"
	type="button"
	(click)="!busy ? buttonClicked($event) : null"
	[disabled]="disabled"
	[style.width]="width ? width : '100%'"
	[TealiumLink]="{interaction_type : 'button'}"
>
	<div class="inner" [ngClass]="color" [style.border-radius.px]="radius">
		<div class="busy" *ngIf="busy">
			<mat-spinner
				color="spinnerColor"
				[diameter]="27"
				[strokeWidth]="4"
			></mat-spinner>
		</div>
		<div
			class="content"
			[style.padding-left.px]="contentPadding"
			[style.padding-right.px]="contentPadding"
			*ngIf="!busy"
		>
			<ng-content></ng-content>
		</div>
	</div>
</button>
